import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const OfflineEntryForm = lazy(() => import('../../container/crm/offline/OfflineEntryForm'));
const OfflineHistory = lazy(() => import('../../container/crm/offline/OfflineHistory'));
const CrmPage = lazy(() => import('../../container/crm/CrmPage'));
const CRMLayout = lazy(() => import('../../container/crm/overview/CRMLayout'));

function CrmRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/offline/new`} component={OfflineEntryForm} />
      <Route exact path={`${path}/offline/:customerId`} component={OfflineHistory} />
      <Route path={`${path}/table`} component={CrmPage} />
      <Route exact path={`${path}/layout/:conversationId`} component={CRMLayout} />
    </Switch>
  );
}

export default CrmRoutes;
